module.exports = __webpack_public_path__ + "img/cycle-SP.55e4c02f.png";